export default __webpack_public_path__ + "static/media/twitter.dcc54a6e.png";